module.exports = __webpack_public_path__ + "img/icon-shrink.4d62c566.svg";